import {useTheme} from "next-themes";
import {FaSun} from "react-icons/fa";
import React from "react";

export const Theme = () => {
    const {theme, setTheme} = useTheme();

    return (
        <div className="btn-theme">
            <FaSun onClick={() => setTheme(theme === "dark" ? "light" : "dark")}/>
        </div>
    );
}